import { render, staticRenderFns } from "./ImgAvatar.vue?vue&type=template&id=0f8a02ef&scoped=true&"
import script from "./ImgAvatar.ts?vue&type=script&lang=ts&"
export * from "./ImgAvatar.ts?vue&type=script&lang=ts&"
import style0 from "./ImgAvatar.scss?vue&type=style&index=0&id=0f8a02ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a02ef",
  null
  
)

export default component.exports